import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { getAppointmentReports, updateDailyReportsPagination } from '../../../store/actions/reports/reports_action';
import { Paper, makeStyles, Table, TableBody, TableCell, TableHead, TableRow, TableFooter } from '@material-ui/core';
import TablePagination from '../../ui_components/table_pagination';
import { differenceInMilliseconds, format, getHours, getMinutes } from 'date-fns';
import { intervalToDuration } from 'date-fns/esm';
import { roundNumber } from '../../../utils/helper_functions';

const useStyles = makeStyles((theme) => ({
	paper: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto'
    },
    table: {
        minWidth: 500
    },
    tableRow: {
        cursor: 'pointer'
    }
}));

const getDuration = (startDate, endDate) => {
    const startHours = getHours(startDate);
    const startMinutes = getMinutes(startDate);
    const endHours = getHours(endDate);
    const endMinutes = getMinutes(endDate);

    const difference = differenceInMilliseconds(endDate, startDate);
    let { days, hours, minutes } = intervalToDuration({start: 0, end: difference});

    let duration = '';
    if (days) {
        hours = Math.floor((((endHours * 60 + endMinutes) - (startHours * 60 + startMinutes)) * days) / 60);
    }
    if (hours) {
        duration = `${hours}h`
    }
    if (minutes) {
        duration = `${duration} ${minutes}min`
    }
    return duration;
}

const DailyReportsTable = ({ dailyReports: { collection, totalCount, page, rowsPerPage, filters, values: { totalDoctorPrice = 0, totalTechnicianPrice = 0, totalInsuranceCompanyPrice = 0, totalCompanyPrice = 0 } }, type }) => {
    const { paper, table, tableRow } = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!collection.length) {
            dispatch(getAppointmentReports({ page, rowsPerPage, filters }));
        }
    }, []);

    return (
            <Paper className={paper}>
                <Table aria-label="table" className={table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Klijent</TableCell>
                            {type === 1 &&
                                <TableCell>Doktor</TableCell>
                            }
                            {type === 2 &&
                                <TableCell>Tehničar</TableCell>
                            }
                            {type === 3 &&
                                <TableCell>Osiguravajuća kuća</TableCell>
                            }
                            <TableCell>Usluga</TableCell>
                            <TableCell>Početak - Kraj</TableCell>
                            <TableCell>Utrošeno vreme</TableCell>
                            <TableCell>Plaćeno?</TableCell>
                            {type === 1 &&
                                <TableCell>Prihod doktora / prihod kompanije</TableCell>
                            }
                            {type === 2 &&
                                <TableCell>Prihod tehničara / prihod kompanije</TableCell>
                            }
                            {type === 3 &&
                                <TableCell>Prihod osiguravajuće kuće / prihod kompanije</TableCell>
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {collection.map(({ customer: { firstName, lastName }, worker, technician, insuranceCompany, article: { name: articleName }, startDate, endDate, companyPrice, doctorPrice, technicianPrice, insuranceCompanyPrice, isPayed }, index) =>
                            <TableRow hover key={index} className={tableRow}>
                                <TableCell>{ firstName } { lastName }</TableCell>
                                {type === 1 &&
                                    <TableCell>{ worker && `${worker?.firstName} ${worker?.lastName}` }</TableCell>
                                }
                                {type === 2 &&
                                    <TableCell>{ technician && `${technician?.firstName} ${technician?.lastName}` }</TableCell>
                                }
                                {type === 3 &&
                                    <TableCell>{ insuranceCompany && `${insuranceCompany?.firstName} ${insuranceCompany?.lastName}` }</TableCell>
                                }
                                <TableCell>{ articleName }</TableCell>
                                <TableCell width="20%">
                                    {format(new Date(startDate), 'dd.MM.yyyy HH:mm')} - {format(new Date(endDate), 'HH:mm')}
                                </TableCell>
                                <TableCell>{ getDuration(new Date(startDate), new Date(endDate)) }</TableCell>
                                <TableCell>{ isPayed ? 'Da' : 'Ne' }</TableCell>
                                {type === 1 &&
                                    <TableCell>{ roundNumber(doctorPrice)} / { roundNumber(companyPrice) }</TableCell>
                                }
                                {type === 2 &&
                                    <TableCell>{ roundNumber(technicianPrice)} / { roundNumber(companyPrice) }</TableCell>
                                }
                                {type === 3 &&
                                    <TableCell>{ roundNumber(insuranceCompanyPrice)} / { roundNumber(companyPrice) }</TableCell>
                                }
                            </TableRow>
                        )}
                    </TableBody>
                    <TableFooter>
                        <TableRow hover>
                            <TableCell colSpan={6} align="right">Ukupan prihod</TableCell>
                                {type === 1 &&
                                    <TableCell>{ roundNumber(totalDoctorPrice) } / { roundNumber(totalCompanyPrice) }</TableCell>
                                }
                                {type === 2 &&
                                    <TableCell>{ roundNumber(totalTechnicianPrice) } / { roundNumber(totalCompanyPrice) }</TableCell>
                                }
                                {type === 3 &&
                                    <TableCell>{ roundNumber(totalInsuranceCompanyPrice) } / { roundNumber(totalCompanyPrice) }</TableCell>
                                }
                        </TableRow>
                    </TableFooter>
                    <TablePagination
                        page={page}
                        rowsPerPage={rowsPerPage}
                        count={totalCount}
                        updatePagination={updateDailyReportsPagination}
                        filters={filters}
                    />
                </Table>
            </Paper>
    )
}

DailyReportsTable.propTypes = {
    dailyReports: PropTypes.object,
    type: PropTypes.number
}

const mapStateToProps = (state) => ({
    dailyReports: state.dailyReports
});

export default connect(mapStateToProps)(DailyReportsTable);
